import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "dataTables_wrapper dt-bootstrap4 no-footer" }
const _hoisted_2 = { class: "table-responsive" }
const _hoisted_3 = {
  class: "\n          table\n          align-middle\n          table-row-dashed\n          fs-6\n          gy-5\n          dataTable\n          no-footer\n        ",
  id: "kt_customers_table",
  role: "grid"
}
const _hoisted_4 = {
  class: "text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0",
  role: "row"
}
const _hoisted_5 = { class: "fw-bold text-gray-600" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "\n          col-sm-12 col-md-5\n          d-flex\n          align-items-center\n          justify-content-center justify-content-md-start\n        " }
const _hoisted_8 = {
  key: 0,
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("option", { value: "10" }, "10", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("option", { value: "25" }, "25", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("option", { value: "50" }, "50", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("option", { value: "100" }, "100", -1)
const _hoisted_13 = { class: "\n          col-sm-12 col-md-7\n          d-flex\n          align-items-center\n          justify-content-center justify-content-md-end\n        " }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("table", _hoisted_3, [
        _createVNode("thead", null, [
          _createVNode("tr", _hoisted_4, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tableHeader, (cell, i) => {
              return (_openBlock(), _createBlock("th", {
                key: i,
                onClick: ($event: any) => (
                  _ctx.sort(
                    cell.sortingField ? cell.sortingField : cell.key,
                    cell.sortable
                  )
                ),
                class: [
                  cell.name && 'min-w-125px',
                  cell.sortable && 'sorting',
                  _ctx.tableHeader.length - 1 === i && 'text-end',
                  _ctx.currentSort ===
                    `${cell.sortingField ? cell.sortingField : cell.key}2` &&
                    'sorting_desc',
                  _ctx.currentSort ===
                    `${cell.sortingField ? cell.sortingField : cell.key}1` &&
                    'sorting_asc',
                ],
                tabindex: "0",
                rowspan: "1",
                colspan: "1",
                style: {"cursor":"pointer"}
              }, _toDisplayString(cell.name), 11, ["onClick"]))
            }), 128))
          ])
        ]),
        _createVNode("tbody", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getItems, (item, i) => {
            return (_openBlock(), _createBlock("tr", {
              key: i,
              class: "odd"
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tableHeader, (cell, i) => {
                return (_openBlock(), _createBlock("td", {
                  key: i,
                  class: { 'text-end': _ctx.tableHeader.length - 1 === i }
                }, [
                  _renderSlot(_ctx.$slots, `cell-${cell.key}`, { row: item }, () => [
                    _createTextVNode(_toDisplayString(item[_ctx.prop]), 1)
                  ])
                ], 2))
              }), 128))
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        (_ctx.enableItemsPerPageDropdown)
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _createVNode("label", null, [
                _withDirectives(_createVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination.rowsPerPage = $event))
                }, [
                  _hoisted_9,
                  _hoisted_10,
                  _hoisted_11,
                  _hoisted_12
                ], 512), [
                  [_vModelSelect, _ctx.pagination.rowsPerPage]
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_13, [
        _createVNode(_component_el_pagination, {
          background: "",
          layout: "prev, pager, next",
          onCurrentChange: _ctx.setCurrent,
          "hide-on-single-page": true,
          "page-count": _ctx.pages,
          "page-size": parseInt(_ctx.pagination.rowsPerPage),
          total: _ctx.pagination.total
        }, null, 8, ["onCurrentChange", "page-count", "page-size", "total"])
      ])
    ])
  ]))
}